import Layout from "@/components/layout/Layout";
import HeroSection from "@/components/home/HeroSection";
import UseCaseSection from "@/components/home/UseCaseSection";
import IntegrationSection from "@/components/home/IntegrationSection";
import IndustrySection from "@/components/home/IndustrySection";
import CaseStudySection from "@/components/home/CaseStudySection";
import CTASection from "@/components/home/CTASection";
import { useEffect } from "react";

export default function HomePage() {
  useEffect(() => {
    // Set page title
    document.title = "AI Automation Co. | Automate Your Business with AI";
  }, []);

  return (
    <Layout data-id="vdllzobav" data-path="src/pages/HomePage.tsx">
      <HeroSection data-id="cl5g0972b" data-path="src/pages/HomePage.tsx" />
      <UseCaseSection data-id="to8fj9l4t" data-path="src/pages/HomePage.tsx" />
      <IntegrationSection data-id="7p99meab6" data-path="src/pages/HomePage.tsx" />
      <IndustrySection data-id="d7042hxm2" data-path="src/pages/HomePage.tsx" />
      <CaseStudySection data-id="v1hgsx3sc" data-path="src/pages/HomePage.tsx" />
      <CTASection data-id="ho2x6babo" data-path="src/pages/HomePage.tsx" />
    </Layout>);

}